import { FC, FormEvent, ReactNode, useCallback } from "react";

import { useFormContext } from "@/v2/context/FormContext/FormProvider/FormProvider";
import { FormContext } from "@/v2/context/FormContext/types";

interface FormProps {
  children: ReactNode;
  id?: string;
  onSuccess?: (state: any, formApi: FormContext) => void;
  onError?: () => void;
  noValidate?: boolean;
}

export const Form: FC<FormProps> = ({ children, id, onSuccess, onError, noValidate = true }) => {
  const formApi = useFormContext();
  const { checkChildErrors, getState } = formApi;

  const handleSubmit = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      const hasErrors = await checkChildErrors();

      if (onSuccess && !hasErrors) onSuccess(getState(), formApi);
      if (onError && hasErrors) onError();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onSuccess],
  );

  return (
    <form id={id} onSubmit={handleSubmit} noValidate={noValidate}>
      {children}
    </form>
  );
};
